module.exports = __webpack_public_path__ + "static/media/Step1Option2.c976d062.jpg";